import { doc, collection } from 'firebase/firestore';
import { db, app } from '../firebase.config';

// Artifacts collection uses the Firebase project ID as the document ID (e.g. acc-app-e5316).
// Do NOT use getStoredAppId() here: the session "appId" is app_${uid} and is not a Firestore path.
const ARTIFACTS_DOC_ID = (typeof app !== 'undefined' && app?.options?.projectId) ? app.options.projectId : 'acc-app-e5316';

/** Backward compatibility: same as ARTIFACTS_DOC_ID for Firestore artifacts path. */
export const APP_ID = ARTIFACTS_DOC_ID;

function resolveArtifactsAppId(appIdOverride) {
  return appIdOverride || ARTIFACTS_DOC_ID;
}

export function getUserRoot(userId, appIdOverride) {
  const appId = resolveArtifactsAppId(appIdOverride);
  return doc(db, 'artifacts', appId, 'users', userId);
}

// Main Settings document (fixed id 'default') under the user's Settings collection
export function getSettingsDoc(userId, appIdOverride) {
  const appId = resolveArtifactsAppId(appIdOverride);
  return doc(db, 'artifacts', appId, 'users', userId, 'Settings', 'default');
}

export function getDevicesCollection(userId, appIdOverride) {
  const appId = resolveArtifactsAppId(appIdOverride);
  // Devices subcollection under the main Settings doc
  return collection(db, 'artifacts', appId, 'users', userId, 'Settings', 'default', 'Devices');
}

export function getSettingsCollection(userId, collectionName, appIdOverride) {
  const appId = resolveArtifactsAppId(appIdOverride);
  return collection(db, 'artifacts', appId, 'users', userId, 'Settings', 'default', collectionName);
}

export function getSettingsSubDoc(userId, subCollectionName, docId, appIdOverride) {
  const appId = resolveArtifactsAppId(appIdOverride);
  return doc(db, 'artifacts', appId, 'users', userId, 'Settings', 'default', subCollectionName, docId);
}

// Backoffice namespace (standardized)
export function getBackofficeAdminDoc(adminUserId, appIdOverride) {
  const appId = resolveArtifactsAppId(appIdOverride);
  return doc(db, 'artifacts', appId, 'backoffice_admins', adminUserId);
}

export function getBackofficeLogsCollection(appIdOverride) {
  const appId = resolveArtifactsAppId(appIdOverride);
  return collection(db, 'artifacts', appId, 'backoffice_logs');
}

export function getBackofficeSubscriptionControlDoc(userId, appIdOverride) {
  const appId = resolveArtifactsAppId(appIdOverride);
  return doc(db, 'artifacts', appId, 'backoffice_subscriptions', userId);
}


